"use strict";

exports.__esModule = true;
var buttonOverride = exports.buttonOverride = function buttonOverride(color, fontColor) {
  return "div[data-theme=\"MozartButton\"] {\n    background: none;\n    color: " + color + ";\n    font-family: 'Montserrat', sans-serif;\n    border: 1px solid " + color + " !important;\n    transition: 0.3s;\n    position: relative;\n  }\n  div[data-theme=\"MozartButton\"] {\n    color: #000;\n  }\n  div[data-theme=\"MozartButton\"]::before{\n    opacity: 1 !important;\n    border: transparent !important;\n    background: " + color + ";\n  }\n  div[data-theme=\"MozartButton\"]:after {\n    content: '';\n    transition: all 0.3s !important;\n    width: 0%;\n    height: 100%;\n    top: 0;\n    left: 0;\n    color: white;\n    z-index: 0;\n  }\n  div[data-theme=\"MozartButton\"]:hover:after {\n    width: 100%;\n    background: " + color + ";\n    color: " + fontColor + ";\n  }\n  div[data-theme=\"MozartButton\"]:hover {\n    width: 100%;\n    background: " + color + ";\n    color: " + fontColor + ";\n  }\n  ";
};

var loaderOverride = exports.loaderOverride = function loaderOverride(color) {
  return ".double-bounce1, .double-bounce2 {\n    background-color:" + color + " !important;\n  }";
};


//////////////////
// WEBPACK FOOTER
// ./src/utils/utils-styles.js
// module id = 2352
// module chunks = 0